module.exports = __webpack_public_path__ + "img/TechArcherArm3_ua.c73a849e.webp";